/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EnqueuedBroadcastResponse } from '../models/EnqueuedBroadcastResponse';
import type { MarkAllReadResponse } from '../models/MarkAllReadResponse';
import type { MessageResponse } from '../models/MessageResponse';
import type { NotificationListItemResponse } from '../models/NotificationListItemResponse';
import type { RegisterTokenDto } from '../models/RegisterTokenDto';
import type { SendNotificationDto } from '../models/SendNotificationDto';
import type { UnreadCountResponse } from '../models/UnreadCountResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class NotificationsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get unread notifications count
     * Returns the total number of unread notifications for the authenticated user.
     * @returns UnreadCountResponse Unread count returned successfully.
     * @throws ApiError
     */
    public notificationsControllerGetUnreadCount(): CancelablePromise<UnreadCountResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/notifications/unread-count',
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * List user's notifications
     * Returns a paginated list of notifications for the authenticated user, newest first. Includes unread count.
     * @returns any
     * @throws ApiError
     */
    public notificationsControllerFindAll({
        page = 1,
        limit = 20,
        sortBy,
        sortOrder = 'desc',
        isRead,
        type,
    }: {
        /**
         * Page number (starts from 1)
         */
        page?: number,
        /**
         * Number of items per page (max 200)
         */
        limit?: number,
        /**
         * Field to sort by
         */
        sortBy?: string,
        /**
         * Sort order (asc or desc)
         */
        sortOrder?: 'asc' | 'desc',
        /**
         * Filter by read status
         */
        isRead?: boolean,
        /**
         * Filter by notification type
         */
        type?: 'WIZZ_ALERT' | 'NOTIFICATION' | 'INTERVENTION' | 'PAYMENT' | 'ACCOUNT_INCOMPLETE' | 'SOCIETY_INCOMPLETE' | 'PROFILE_INCOMPLETE' | 'WELCOME',
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/notifications',
            query: {
                'page': page,
                'limit': limit,
                'sortBy': sortBy,
                'sortOrder': sortOrder,
                'isRead': isRead,
                'type': type,
            },
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * Mark notification as read
     * Marks a single notification as read. Only the owner can mark their own notifications.
     * @returns NotificationListItemResponse Notification marked as read.
     * @throws ApiError
     */
    public notificationsControllerMarkAsRead({
        id,
    }: {
        /**
         * Notification unique identifier
         */
        id: string,
    }): CancelablePromise<NotificationListItemResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/notifications/{id}/read',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Not your notification.`,
                404: `Notification not found.`,
            },
        });
    }
    /**
     * Mark all notifications as read
     * Marks all unread notifications for the authenticated user as read.
     * @returns MarkAllReadResponse All notifications marked as read.
     * @throws ApiError
     */
    public notificationsControllerMarkAllAsRead(): CancelablePromise<MarkAllReadResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/notifications/read-all',
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * Register FCM token
     * Register a Firebase Cloud Messaging device token for the authenticated user.
     * @returns MessageResponse FCM token registered successfully.
     * @throws ApiError
     */
    public notificationsControllerRegisterToken({
        requestBody,
    }: {
        requestBody: RegisterTokenDto,
    }): CancelablePromise<MessageResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/notifications/token',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                404: `User not found.`,
            },
        });
    }
    /**
     * Unregister FCM token
     * Remove a Firebase Cloud Messaging device token from the authenticated user.
     * @returns MessageResponse FCM token removed successfully.
     * @throws ApiError
     */
    public notificationsControllerUnregisterToken({
        requestBody,
    }: {
        requestBody: RegisterTokenDto,
    }): CancelablePromise<MessageResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/notifications/token',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                404: `User not found.`,
            },
        });
    }
    /**
     * Delete a notification
     * Deletes a notification. Only the owner can delete their own notifications.
     * @returns MessageResponse Notification deleted successfully.
     * @throws ApiError
     */
    public notificationsControllerRemove({
        id,
    }: {
        /**
         * Notification unique identifier
         */
        id: string,
    }): CancelablePromise<MessageResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/notifications/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Not your notification.`,
                404: `Notification not found.`,
            },
        });
    }
    /**
     * Broadcast notification (Admin)
     * Enqueue notifications for delivery to targeted users or all users with a specific role. Push notifications are processed asynchronously via pg-boss.
     * @returns EnqueuedBroadcastResponse Broadcast enqueued successfully.
     * @throws ApiError
     */
    public notificationsControllerBroadcast({
        requestBody,
    }: {
        requestBody: SendNotificationDto,
    }): CancelablePromise<EnqueuedBroadcastResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/notifications/broadcast',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
            },
        });
    }
}
